import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";

/*
 * Formattatori per i tab di dettaglio in sola lettura: rendono "-" quando il dato manca,
 * così le griglie etichetta/valore restano allineate.
 */

export const dash = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

/* Gli attributi castati Enumerable/Choiceable arrivano come {cast, text, value} */
export const enumText = (value) => dash(value?.text);

export const dateOrDash = (value) => (value ? toLocaleDate(value) : "-");

export const moneyOrDash = (value) =>
  value === null || value === undefined ? "-" : toLocaleCurrency(value);
